import { parseISO } from 'date-fns';

import { IProject } from 'common/src/types/interfaces';

import { getStartAndEndDateFields } from 'portal/src/components/common/forms/commonFormFields';

import {
  datePickerType,
  numberType,
  selectInputType,
  textInputType,
} from '../../../common/forms/FormFieldTypes';

export const defaultValues = (entity: Partial<IProject> = {}): any => ({
  completionDate: entity.completionDate
    ? parseISO(entity.completionDate)
    : null,
  description: entity.description ?? '',
  estimatedCost: entity.estimatedCost ?? 0,
  estimatedRebate: entity.estimatedRebate ?? 0,
  estimatedUtilitySavings: entity.estimatedUtilitySavings ?? 0,
  facilities: entity.facilities ?? [],
  name: entity.name ?? '',
  startDate: entity.startDate ? parseISO(entity.startDate) : null,
});

export const getProjectFields = () => {
  const formFieldsConfiguration: Array<
    datePickerType | textInputType | selectInputType | numberType
  > = [
    {
      placeholder: 'Project Name',
      label: 'Project Name',
      name: 'name',
      type: 'textInput',
      required: true,
    },
    {
      placeholder: 'Description',
      label: 'Description',
      name: 'description',
      type: 'textInput',
      required: false,
    },
    ...getStartAndEndDateFields({
      endFieldName: 'completionDate',
      endLabel: 'Completion Date',
      required: true,
    }),
    {
      placeholder: 'Estimated Cost',
      label: 'Estimated Cost',
      name: 'estimatedCost',
      type: 'number',
      required: true,
      adorment: '$ ',
      allowNegative: true,
      autoDecimalFormat: true,
    },
    {
      placeholder: 'Estimated Rebate',
      label: 'Estimated Rebate',
      name: 'estimatedRebate',
      type: 'number',
      required: true,
      adorment: '$ ',
      allowNegative: true,
      autoDecimalFormat: true,
    },
    {
      placeholder: 'Estimated Utility Savings',
      label: 'Estimated Utility Savings',
      name: 'estimatedUtilitySavings',
      type: 'number',
      required: true,
      adorment: '$ ',
      allowNegative: true,
      autoDecimalFormat: true,
    },
  ];
  return formFieldsConfiguration;
};
